const TIPO_PERFIL_DENTISTA = 3

const normalizarTexto = (texto) =>
  (texto || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toUpperCase()
    .trim()

export const ehPerfilExcluidoDaListagem = (perfil) => {
  if (!perfil) return false
  if (perfil.tipoPerfil === TIPO_PERFIL_DENTISTA) return true

  const nome = normalizarTexto(perfil.nome)
  return nome.includes('DENTISTA') || (nome.includes('COBRAN') && nome.includes('JURID'))
}

export const filtrarColaboradoresPorPerfisPermitidos = (colaboradores = [], perfis = []) => {
  const perfisExcluidosIds = new Set(
    (perfis || []).filter(ehPerfilExcluidoDaListagem).map((perfil) => perfil.id)
  )

  return (colaboradores || []).filter(
    (colaborador) => colaborador.ativo && !perfisExcluidosIds.has(colaborador.perfilId)
  )
}
